import React from "react";
import fallbackAvatar from "../../assets/images/profile1.png";
import { ReferralHistorySkeleton } from "./ReferralShimmers";
import "./Referralearn.css";

const typeMeta = {
  transfer: { label: "Transfer", icon: "fa-solid fa-arrow-right-arrow-left", className: "transfer-btn" },
  reward: { label: "Reward", icon: "fa-solid fa-gift", className: "reward-btn" },
  bonus: { label: "Bonus", icon: "fa-solid fa-star", className: "bonus-btn" },
};

function HistoryRow({ item }) {
  const coins = Number(item?.coins) || 0;
  const debit = String(item?.direction || "").toLowerCase() === "debit" || coins < 0;
  const type = typeMeta[String(item?.type || "").toLowerCase()] || { label: "Referral", icon: "fa-solid fa-user-plus", className: "referral-btn" };
  const fee = item?.fee_coins == null ? "" : String(item.fee_coins);
  return <div className="history-card">
    <div className="history-user">
      <div className={`history-avatar ${type.label === "Reward" ? "reward-avatar" : ""}`}>
        <img src={item?.profile || fallbackAvatar} alt="" onError={(event) => { event.currentTarget.onerror = null; event.currentTarget.src = fallbackAvatar; }} />
        <span className="history-avatar-badge"><i className={type.icon} /></span>
      </div>
      <div className="history-details">
        <h3>{item?.title || "Referral"}</h3>
        {item?.name && <strong>{item.name}</strong>}
        {item?.email && <p className="history-email">{item.email}</p>}
        {(item?.display_date || item?.created_at) && <p className="history-date"><i className="bi bi-clock" />{item.display_date || item.created_at}</p>}
      </div>
    </div>
    <div className="history-action">
      <div className={`history-amount ${debit ? "amount-negative" : "amount-positive"}`}>{debit ? "-" : "+"}{Math.abs(coins)}</div>
      {fee && fee !== "0" && <div className="history-fee"><i className="bi bi-receipt-cutoff" /> Fee: {fee}</div>}
      <span className={`history-action-btn ${type.className}`}>{type.label}</span>
    </div>
  </div>;
}

export default function HistoryTab({ query }) {
  const items = query.data?.pages?.flatMap((page) => page.items) || [];
  if (query.isPending) return <div className="history-page"><ReferralHistorySkeleton /></div>;
  return <div className="history-page">
    {query.isError && <div className="referral-status" role="alert"><p>{query.error?.message || "Unable to load referral history."}</p><button type="button" onClick={() => query.isFetchNextPageError ? query.fetchNextPage() : query.refetch()}>Retry</button></div>}
    {items.length ? <div className="history-list">{items.map((item, index) => <HistoryRow item={item} key={`${item?.id ?? "row"}-${index}`} />)}</div> : !query.isError && <p className="referral-empty">No referral history yet.</p>}
    {query.hasNextPage && !query.isError && <button type="button" className="referral-load-more" onClick={() => query.fetchNextPage()} disabled={query.isFetchingNextPage}>{query.isFetchingNextPage ? "Loading..." : "Load more"}</button>}
  </div>;
}
